/**
 * Allow a member to send an email or video message to the appropriate decision maker
 */
import { pluginRegistry } from "@flow/frontend/member/plugin_api";
import { SendAMessageAction_def } from "../../common/action_types";
import { SendAMessageActionComponent } from "./SendAMessageActionComponent";

pluginRegistry.registerActionComponent(SendAMessageAction_def, (props) => {
  return <SendAMessageActionComponent {...props} />;
});
